import clsx from 'clsx';
import type {
  GroupBase,
  MultiValueProps as ReactSelectMultiValueProps,
} from 'react-select';

import { selectMultiValueCSS } from '../styles/Select.sty.js';
import type { BaseGroup, BaseOption } from '../types.js';

type MultiValueProps<
  OptionValue,
  isMulti extends boolean,
  Group extends GroupBase<OptionValue>,
> = ReactSelectMultiValueProps<OptionValue, isMulti, Group>;

export function MultiValue<
  OptionValue,
  isMulti extends boolean,
  Group extends BaseGroup<OptionValue>,
>(props: MultiValueProps<BaseOption<OptionValue>, isMulti, Group>) {
  const { data } = props;

  return (
    <span className={clsx(selectMultiValueCSS)} style={{ display: 'inline' }}>
      {data.label}
    </span>
  );
}
